import { Component, OnInit, EventEmitter, Output, TemplateRef } from '@angular/core';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { of, Subscription } from 'rxjs';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DomSanitizer,  } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
const FileSaver = require('file-saver');
import { FormsService } from '../../services/forms.service';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-html-data',
  templateUrl: './html-data.component.html',
  styleUrls: ['./html-data.component.scss'],
  providers: [DatePipe]
})

export class HTMLDataComponent implements OnInit {
  @Input() folderID :number=0;  
  organizationId: string;
  databaseId: string;
  currentUser: any;
  CloseViewDocument:boolean = false;  
  clickEventsubscriptionFormHtmlData: Subscription;
  responseHolder: any; 
    
  folderList: any[] = [];
  folderId:number=0;  
  spinner:boolean=false;
  @Output() getCloseHtmlData = new EventEmitter<boolean>();  

  ShowHeader:boolean=false;
  ShowFooter:boolean=false;
  HeaderFooter:any=[]=[];
  OfficeIDList: any = [];
  myOfficeID: any;
  ResponseHolderDetails: any;
  controlAlignArray: any = [];
  dataJson: any = [];
  transactionID:number=0;
  placeholderID:number=0;
 
  list_items :any=[]=[];
  keys :any=[]=[];

  datatable:any=[]=[];
  displayColumn:any=[]=[];
  noRecordFound:boolean = false; 
  formID:number=0;
  formName:string="";
  myFormGroup: FormGroup;
  dateRange: any;
  startDate:any;
  endDate:any;

  constructor(private formsService:FormsService, private dialog: MatDialog, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    private statusConst: StatusConstant, public sanitizer: DomSanitizer,
    private toastr: ToastrService, 
    private loaderService: LoaderService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

   ngOnDestroy() {
    this.clickEventsubscriptionFormHtmlData.unsubscribe()
   }
 
   ngOnInit(): void {
    this.clickEventsubscriptionFormHtmlData = this._dataSharingService.getSelectedHTMLDataForForm().subscribe((result) => {
      if (result) {     
         this.formID = Object.values(result)[0];  
         this.formName =  Object.values(result)[1];  
         this.getHtmlFormData();     
      }      
    });   


    this.myFormGroup = this.formBuilder.group({
      
      dateRange:""
    });

  }

    

   searchKeyword: string = "";

    searchFormData(){
      this.getHtmlFormData();
    }

   clearSearchData(){
    this.searchKeyword = ""
    this.getHtmlFormData();
   }

   clearDateRange(){
    this.dateRange = null;
    this.selectedDateRanges = null
    this.getHtmlFormData();
   }

   selectedDateRanges:any;

   selectedDateRange(event){
    this.startDate = (moment(event.startDate).format("MM/DD/YYYY"));
    this.endDate = (moment(event.endDate).format("MM/DD/YYYY"));

    this.selectedDateRanges = {
      from: this.startDate,
      to: this.endDate
    }

   }

   gridSettingData:any=[]=[];

   getHtmlFormData(){
    var ReqModel = {
      formID: Number(this.formID),
      searchKeyword: this.searchKeyword,
      searchDateRange: this.selectedDateRanges,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,     
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),            
    };
    this.loaderService.show();
    this.datatable=[];
    this.formsService.getHtmlFormData(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {        
         if(this.ResponseHolderDetails.data.forms.length>0){
          this.noRecordFound=false;
          var formData=[];
          //this.formName= this.ResponseHolderDetails.data.forms[0].formName;  
          var isCheckInForm=this.ResponseHolderDetails.data.forms[0].isCheckIn;
          formData= this.ResponseHolderDetails.data.forms[0].formData;

          this.ExcelData=[];

          if(formData.length>0){
            for (var i = 0, len = formData.length; i < len; ++i) {
              var jsonData = [];
              //var jsonDataNew = [];
              var UserData={
                ctrlType: "text",
                id: "UserName",
                name: "Submited By",
                value: formData[i].submitBy,
              }
              // Create checkIn and CheckOut JSON and add with jsonData
              jsonData = JSON.parse(formData[i].jsonData);
              jsonData = jsonData.filter(x=> x.isShowListing!=true);
              jsonData.splice(0, 0, UserData); 
              if(isCheckInForm==true){
                var CheckInData={
                  ctrlType: "checkIn",
                  id: "checkIn",
                  name: "CheckIn Date",
                  value: formData[i].checkInDate== undefined? "-": this.datePipe.transform(formData[i].checkInDate, "MM/dd/yyyy hh:mm:ss a")
                }
                var CheckOutData={
                  ctrlType: "checkOut",
                  id: "checkOut",
                  name: "checkOut Date",
                  value: formData[i].checkOutDate== undefined?"-": this.datePipe.transform(formData[i].checkOutDate, "MM/dd/yyyy hh:mm:ss a"),
                }
              jsonData.splice(2, 0, CheckInData,CheckOutData); 
              }
              for (var i1 = 0, len1 = jsonData.length; i1 < len1; ++i1) {
                var value="";
                var check=[];
                check = this.datatable.filter(x=>x.id == jsonData[i1].id);
                if(check.length>0){
                  if(jsonData[i1].value!=""){
                    value=jsonData[i1].value;
                  }else{
                    value="-";
                  }
                  var FileName="";
                  if(jsonData[i1].name=="File" && jsonData[i1].type=="image"){
                    FileName = jsonData[i1].FileName;              
                  }else{
                    FileName ="";            
                  }
                  this.datatable.find(x => x.id == jsonData[i1].id).value.push(value);               
                }else{
                  if(jsonData[i1].value!=""){
                    value=jsonData[i1].value;
                  }else{
                    value="-";
                  }
                 
                  var FileName="";
                  if(jsonData[i1].name=="File" && jsonData[i1].type=="image"){
                    FileName = jsonData[i1].FileName;              
                  }else{
                    FileName ="";            
                  }
                
                  var type="";
                  var checkType= jsonData[i1].id.split('-');
                  if(checkType.length>0){
                    type = checkType[0];
                  }else{
                    type = checkType;
                  }           
                 
                  if(type=="embedImage"){
                    type="Image";
                  }
                  var req = {
                    columnName: jsonData[i1].name,
                    type: type,//jsonData[i1].type,
                    id: jsonData[i1].id,
                    value: [value],
                    FileName: FileName,            
                  }          
                  this.datatable.push(req);
                }  
              
               var types="";
               var checksType= jsonData[i1].id.split('-');
               if(checksType.length>0){
                types = checksType[0];
               }else{
                types = checksType;
               }           
              
               if(types=="embedImage"){
                types="Image";
               }
                if(types!="Signature" && types!="Initials" && types!="Image" && types!="File"){
                  var data=[];
                  var obj:any;
                if(i1==0){
                 let submittedEmail = "Submitted By";
                   obj=[{
                   [submittedEmail]: jsonData[i1].value
                   }]
                }
               if(i1>0){     
                  var checks=[];
                  checks= this.ResponseHolderDetails.data.forms[0].gridSetting;
                  if(checks==null){
                    var obj1={
                      [jsonData[i1].name]: jsonData[i1].value
                      }
                      data.push(obj1);
                   }else{
                    checks = this.ResponseHolderDetails.data.forms[0].gridSetting.filter(x=>x.id==jsonData[i1].id); 
                    if(checks.length>0){                       
                       if(checks[0].isDisplay==true){
                        var obj2={
                          [jsonData[i1].name]: jsonData[i1].value
                          }
                          data.push(obj2);
                       }
                     }
                   }      
                }
                  this.mergeByProperty(obj, data, 'name');
                }             
               }   
              var object = Object.assign({}, ...obj);
               this.ExcelData.push(object);         
             }
           } else{
            this.noRecordFound=true;
           } 
           
           this.datatable;
           if (this.datatable.length > 0) {
            let total: number = 0;
          
            // Get the length of the 'value' array of the first record
            total = this.datatable[0].value.length;
          
            // Loop through each record in the datatable
            for (let i = 0; i < this.datatable.length; i++) {
              // Get the current record's value array
              const currentRecordValue = this.datatable[i].value;
          
              // If the length is different, adjust it to match the total
              if (currentRecordValue.length !== total) {
                if (currentRecordValue.length < total) {
                  // If the current value array is shorter, fill it with default values (e.g., null)
                  while (currentRecordValue.length < total) {
                    currentRecordValue.push("-"); // or any default value you'd like to use
                  }
                } else if (currentRecordValue.length > total) {
                  // If the current value array is longer, trim it to match the total
                  currentRecordValue.length = total;
                }
              }
            }
          }
          this.datatable;
          this.gridSettingData=[];
          this.gridSettingData = this.ResponseHolderDetails.data.forms[0].gridSetting;         
          if (this.gridSettingData != null) {
            if (this.datatable.length > 0) {
              for (let i1 = 0; i1 < this.datatable.length; i1++) {
                 var checkData=[];
                 checkData = this.gridSettingData.filter(x=>x.id==this.datatable[i1].id);
                 if(checkData.length>0){
                  this.datatable[i1].isDisplay=checkData[0].isDisplay;
                 }else{
                  this.datatable[i1].isDisplay=true;
                 }
              }
            }
          }else{
            if(this.datatable.length>0){
             this.datatable.forEach(e => {
              e.isDisplay = true
            });
           } 
          }
          this.displayColumn = this.datatable;
         if(this.datatable.length>0){
          this.datatable=this.datatable.filter(x=>x.isDisplay==true);
         }
         }else{
          this.noRecordFound=true;
         } 
          this.loaderService.hide();
         } else {
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }

   
  DownloadFile(record:any,row:any) {
    if (record !== undefined && record !== null) {
      const data = record;//'data:' + record.FileExtention + ';base64,' + record.base64URL;
      FileSaver.saveAs(data, row.FileName);
    }else{
      this.toastr.error('File download failed.', '', {
        timeOut: 3000,
      });
    }
  }
  
  CloseHTMLData(message:boolean){ 
     this.noRecordFound=false;
     this.datatable=[];
     this.getCloseHtmlData.emit(message);
     this._dataSharingService.sendSelectedHTMLDataForCore(null);
  }

  ExcelData:any=[]=[];
    
   downloadData(){

    //var str =  this.formName;
    //var newName = str.substring(0,3);

     /* create a new blank" */
     var wb = XLSX.utils.book_new();
     /* create a worksheet */
     var excel = XLSX.utils.json_to_sheet(this.ExcelData);
     XLSX.utils.book_append_sheet(wb, excel, this.formName);
  
     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
     const data1 = new Blob([excelBuffer], { type: fileType });
     FileSaver.saveAs(data1,"Records.xlsx");

    }


    mergeByProperty = (target: any[], source: any[], prop: string | number) => {
      source.forEach(sourceElement => {
        let targetElement = target.find(targetElement => {
          return sourceElement[prop] === targetElement[prop];
        })
        targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
      })
    }
    
    SubmitColumnsButton:boolean=false;

    applyFilter(templateRef: TemplateRef<any>) {
      this.SubmitColumnsButton = false;
      // if(this.displayColumn.length>0){
      //   this.displayColumn.forEach(e => {
      //     e.isDisplay = true
      //   });
      // } 
      this.dialog.open(templateRef, {
        panelClass: 'custom-modalbox',
      });
    }

    close(){
      this.dialog.closeAll();
    }

    changedToggle(items, event) {
      this.SubmitColumnsButton = true;      
      if(this.displayColumn.length>0){
        this.displayColumn.find((item) => item.id == items.id).isDisplay = event.checked;
      }       
    }

    onSubmitColumns(){
      if(this.displayColumn.length>0){
        var newTable=[];
        var fields=[];
        newTable=this.displayColumn.filter(x=>x.id!="UserName");       
        if(newTable.length>0){
          for (let i = 0; i < newTable.length; i++){
            var obj={
             "id": newTable[i].id,
             "fieldName": newTable[i].columnName,
             "viewOrder": 0,
             "isDisplay": newTable[i].isDisplay,
             }
             fields.push(obj);
           }
        }      
      }
     var ReqModel={
       fields:fields,
       formID: Number(this.formID),      
       userID: this.currentUser.UID,
       organizationID: Number(this.organizationId),
       officeID: this.myOfficeID,     
       officeIDList: this.OfficeIDList,
       databaseID: Number(this.databaseId),
      }
      this.loaderService.show();
      this.formsService.addWebFormUserSetting(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.ResponseHolderDetails = response;
          this.loaderService.hide();
          if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
             this.toastr.success('Record save successfully', '', {
                  timeOut: 3000,
             });
             this.close();  
             this.getHtmlFormData();
           } else {
            this.loaderService.hide();
          }
        }else{
          this.loaderService.hide();
        }
      });
    }

   tableMockData = [
    {
      "column": "Name",
      "type": "Text",
      "value": [
        "abc",  
        'qwer',
      ]
    },
    {
      "column": "Name",
      "type": "Text",
      "value": [
        "xyz", 
        '', 
      ]
    },
    {
      "column": "sig",
      "type": "image",
      "value": [
         "1",
         '',
      ]
    }  ,
    {
      "column": "sig",
      "type": "image",
      "value": [
         "2",
         '',
      ]
    }   
  ]
  
  
   displayColumns = [
   // { name: "S.No", value: "sNo" },
    { name: "Name", value: "Name" },
    { name: "Name", value: "Name1" },
    { name: "Sign", value: "Sign" },
    // { name: "Quantity", value: "Quantity" },
    // { name: "Weight", value: "Weight" },
    // { name: "TotalAmount", value: "TotalAmount" },
    // { name: "TotalOrders", value: "TotalOrders" }
  ];

  userInfoList = [
    {
      Name: "bindu",
      Name1: "bindu1",
      Sign: "abc",
      // Quantity: "4232",
      // Weight: "8970.9700",
      // TotalAmount: "28810924.31",
      // TotalOrders: "135",
      // sNo: 1
    }
    
  ];
}

